<mat-card>
  <app-headline>
    <h1 app-headline-title
        color="primary">Batteries</h1>
  </app-headline>

  <app-filter [columns]="['keywords']">
    <mat-form-field appearance="outline"
                    filter-control
                    size="long">
      <mat-label>Search</mat-label>
      <input matInput
             formControlName="keywords">
    </mat-form-field>
  </app-filter>

  <ngrx-busy>
    <div class="overflow-content" role="region" aria-label="Batteries table" tabindex="0">
      <table mat-table
             [dataSource]="dataSource"
             matSort
             matSortActive="create_date"
             matSortDirection="desc"
             matSortDisableClear>

        <ng-container matColumnDef="id">
          <th mat-header-cell
              *matHeaderCellDef>Battery id
          </th>
          <td mat-cell
              *matCellDef="let row"
              class="min-width">
            <app-code>{{row.id}}</app-code>
          </td>
        </ng-container>

        <ng-container matColumnDef="serial">
          <th mat-header-cell
              *matHeaderCellDef>Serial number
          </th>
          <td mat-cell
              *matCellDef="let row">{{row.serial}}</td>
        </ng-container>

        <ng-container matColumnDef="create_date">
          <th mat-header-cell
              *matHeaderCellDef
              mat-sort-header>Create date
          </th>
          <td mat-cell
              *matCellDef="let row"
              class="min-width">{{row.created_at | utc | moment:'medium'}}</td>
        </ng-container>

        <tr mat-header-row
            *matHeaderRowDef="columns"></tr>
        <tr mat-row
            *matRowDef="let row; columns: columns"></tr>
      </table>
    </div>
    <mat-paginator></mat-paginator>
  </ngrx-busy>
</mat-card>
